import { DyTableColumn } from 'src/app/dynamic/model/dy-model';

export const TABLE_CONFIG_COLUMNS_PMS_CONFIGURATION: DyTableColumn[] = [
  {
    dataKey: 'actions',
    label: 'Action',
    width: 100,
    type: 'action',
    alignClass: 'text-start',
    actions: [
      {
        name: 'edit',
        iconName: 'pencil',
      },
    ],
  },
  {
    dataKey: 'scheduleJob',
    label: 'Schedule Job',
    width: 100,
    alignClass: 'text-center',
    type: 'action',
    actions: [
      {
        name: 'scheduleJob',
        iconName: 'schedule-job',
      },
    ],
  },
  {
    dataKey: 'inviteuser',
    label: 'Invite User',
    width: 200,
    type: 'button',
    alignClass: 'text-center',
    actions: [
      {
        name: 'invite',
      },
    ],
  },
  {
    dataKey: 'licenseKey',
    label: 'License Key',
    width: 100,
    alignClass: 'text-center',
    type: 'action',
    actions: [
      {
        name: 'copy',
        iconName: 'copy',
      },
    ],
  },
  {
    dataKey: 'pmsWidget',
    label: 'PMS widget',
    width: 100,
    type: 'action',
    alignClass: 'text-center',
    actions: [
      {
        name: 'download',
        iconName: 'download',
      },
    ],
  },
  { dataKey: 'dbaName', label: 'DBA', width: 200, type: 'text' },
  {
    dataKey: 'name',
    label: 'Practice Name',
    width: 200,
    type: 'text',
  },
  { dataKey: 'pmsName', label: 'PMS Name', width: 200, type: 'text' },
  {
    dataKey: 'contactPersonName',
    label: 'Contact Person Name',
    width: 200,
    type: 'text',
  },
  // {
  //   dataKey: 'scheduleTime',
  //   label: 'Schedule Job',
  //   width: 150,
  //   type: 'text',
  // },
  {
    dataKey: 'status',
    label: 'Status',
    width: 200,
    alignClass: 'text-center',
    type: 'widget',
  },
];

export const TABLE_CONFIG_COLUMNS_SCHEDULE_JOB: DyTableColumn[] = [
  // {
  //   dataKey: 'actions',
  //   label: 'Action',
  //   width: 100,
  //   type: 'action',
  //   alignClass: 'text-start',
  //   actions: [
  //     {
  //       name: 'edit',
  //       iconName: 'pencil',
  //     },
  //   ],
  // },
  { dataKey: 'jobName', label: 'Job Name', width: 200, type: 'text' },
  // {
  //   dataKey: 'cronExpression',
  //   label: 'CRON Expression',
  //   width: 200,
  //   type: 'text',
  // },
  {
    dataKey: 'cronExpressionDescription',
    label: 'Scheduled Time and Frequency',
    width: 300,
    type: 'text',
  },
  {
    dataKey: 'dataContextName',
    label: 'Data Contexts extracted',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'statusName',
    label: 'Status',
    width: 200,
    type: 'text',
  },
];
